const AVATAR_COLOR_CLASSES = [
  { bg: "bg-sky-100", text: "text-sky-700" },
  { bg: "bg-violet-100", text: "text-violet-700" },
  { bg: "bg-emerald-100", text: "text-emerald-700" },
  { bg: "bg-amber-100", text: "text-amber-800" },
  { bg: "bg-rose-100", text: "text-rose-700" },
  { bg: "bg-cyan-100", text: "text-cyan-800" },
  { bg: "bg-fuchsia-100", text: "text-fuchsia-700" },
  { bg: "bg-lime-100", text: "text-lime-800" },
] as const;

function hashString(value: string): number {
  let hash = 0;

  for (let index = 0; index < value.length; index += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(index);
    hash |= 0;
  }

  return Math.abs(hash);
}

export function getTeamMemberInitials(member: {
  first_name: string;
  last_name: string;
}): string {
  const first = member.first_name.trim().charAt(0).toUpperCase();
  const last = member.last_name.trim().charAt(0).toUpperCase();
  const initials = `${first}${last}`.trim();

  return initials || "?";
}

export function getTeamMemberAvatarColorClasses(seed: string): {
  bg: string;
  text: string;
} {
  const index = hashString(seed) % AVATAR_COLOR_CLASSES.length;
  return AVATAR_COLOR_CLASSES[index] ?? AVATAR_COLOR_CLASSES[0];
}
